import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
	Wrapper,
	Input,
	Label,
	ErrorMsg,
} from './formStyles';

class StyledInput extends PureComponent {
	render () {
		const { id, placeholder, className, errorMsg, deskHeight, ...props } = this.props;
		return (
			<Wrapper className={className} invalid={!!errorMsg} deskHeight={deskHeight}>
				<Input id={id} deskHeight={deskHeight} {...props} invalid={!!errorMsg} className={classNames({ "valid": !!props.value })} />
				<Label htmlFor={id}>{placeholder}</Label>
				<ErrorMsg show={!!errorMsg}>{errorMsg}</ErrorMsg>
			</Wrapper>
		);
	}

	static propTypes = {
		id: PropTypes.string.isRequired,
		placeholder: PropTypes.string.isRequired,
		className: PropTypes.string,
		errorMsg: PropTypes.string,
		deskHeight: PropTypes.string,
	}
}

export default StyledInput;
